import { useCurrentUser } from './CurrentUserProvider';
export function buildPolicyHook(CustomPolicy) {
  return function usePolicy(record) {
    const currentUser = useCurrentUser();
    const recordWithFallback = record !== null && record !== void 0 ? record : null;
    const policy = new CustomPolicy(currentUser, recordWithFallback);
    return policy;
  };
}